import Dialog from 'global/guides/Dialog'
import { useCentroCustoOutletContext } from 'pages/CentroCusto.context'
import { useParams } from 'react-router-dom'
import { AssociarFuncionarioForm } from '../forms/AssociarFuncionarioForm'

export default function AssociarCentroCusto() {
    const { id } = useParams()
    const { data } = useCentroCustoOutletContext()
    const centroCusto = data?.find(item => item.id === Number(id))

    if (!centroCusto) return null

    return (
        <Dialog.Root defaultValues={centroCusto}>
            <Dialog.Title>
                Associar funcionários ao centro de custo{' '}
                {centroCusto.nomeCentroCusto}
            </Dialog.Title>
            <Dialog.Content>
                <AssociarFuncionarioForm />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
